import { usePermissions } from 'react-admin';
import { useRegion } from './RegionContext';
import { toRole, type AccessContext } from './permissions';

export interface AccessState extends AccessContext {
  readonly isLoading: boolean;
}

/**
 * The current user's access context: role (from `getPermissions` / `custom:role`)
 * and accessible regions (from the region context). Used by both the route guard
 * (`RequireAccess`) and menu gating, so they share one decision path.
 */
export function useAccessContext(): AccessState {
  const { permissions, isLoading: roleLoading } = usePermissions();
  const { accessibleRegions, isLoading: regionLoading } = useRegion();
  return {
    role: toRole(permissions),
    accessibleRegions,
    isLoading: roleLoading || regionLoading,
  };
}
